// extracted by mini-css-extract-plugin
export default {"buttonPairList":"ButtonPairList_buttonPairList__1T2gN","buttonPair":"ButtonPairList_buttonPair__kNUiz"};